// src/api/client.js
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL || 'https://api.hackatech.com.br';

export const API_BASE = `${BASE.replace(/\/+$/, '')}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// Injeta Authorization: Bearer <token> se existir
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('hat_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Se 401, apaga token
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('hat_token');
    }
    return Promise.reject(err);
  }
);

// ========= endpoints =========
export async function login(username, password) {
  const { data } = await api.post('/auth/login', { username, password });
  localStorage.setItem('hat_token', data.access_token);
  return data;
}

export async function me() {
  const { data } = await api.get('/auth/me');
  return data;
}

export async function listPostsAdmin({ page = 1, size = 10, status, category, featured, language = 'pt' } = {}) {
  const params = { page, size, language };
  if (status) params.status = status;                 // draft|published|archived
  if (category) params.category = category;           // technology|cloud|...
  if (typeof featured === 'boolean') params.featured = featured;
  const { data } = await api.get('/blog/admin/posts', { params });
  return data; // BlogPostListResponse
}

export async function getPost(id) {
  const { data } = await api.get(`/blog/admin/posts/${id}`);
  return data;
}

export async function createPost(payload) {
  const { data } = await api.post('/blog/admin/posts', payload);
  return data;
}

export async function updatePost(id, payload) {
  const { data } = await api.put(`/blog/admin/posts/${id}`, payload);
  return data;
}

export async function publishPost(id) {
  const { data } = await api.post(`/blog/admin/posts/${id}/publish`);
  return data;
}

export async function unpublishPost(id) {
  const { data } = await api.post(`/blog/admin/posts/${id}/unpublish`);
  return data;
}

export async function deletePost(id) {
  const { data } = await api.delete(`/blog/admin/posts/${id}`);
  return data;
}

export async function listPublicPosts({ page = 1, size = 6, language = 'pt', category, featured } = {}) {
  const params = { page, size, language };
  if (category) params.category = category;
  if (typeof featured === 'boolean') params.featured = featured;
  const { data } = await api.get('/blog/posts', { params });
  return data; // List<BlogPostPublic>
}

export async function getPublicPostBySlug(slug) {
  const { data } = await api.get(`/blog/posts/${slug}`);
  return data; // BlogPostDetail
}
